
import { apiCall } from '../api'
import * as braintreeService from './braintree'
import BetterError from '../../utils/betterError'

/**
 * Saves credit card token to user's payment methods
 *
 * @param {string} nonce - credit card token
 * @returns {Promise}
 */
export const addCard = ({ braintreeToken, clientId }) => {
  const isSlateCard = window.location.search.includes('slate=1')
  return apiCall('addCard7', {
    braintree: {
      nonce: braintreeToken,
    },
    requestProcessor: isSlateCard ? 'slate' : 'xo',
    ...(clientId && { client_id: clientId }),
  }).then(({ id }) => ({ paymentMethodId: id }))
}

export const tokenizeCard = async cardData => {
  const { token, errors } = await braintreeService.getNonce(cardData)

  if (errors || !token) {
    throw new BetterError('Please fill in all required fields correctly', { errors })
  }

  return token
}
